import React, { useContext, useState, useEffect } from 'react';
import ButtonGroup from '@visa/vds/button-group';
import ButtonText from '@visa/vds/button-text';
import Typography from '@visa/vds/typography'
import Grid from '@visa/vds/grid';
import Row from '@visa/vds/row';
import Col from '@visa/vds/col';
import Select from '@visa/vds/select';
import { PageHelper } from '../../../_helpers/PageHelper';
import { adminService } from '../../../services/admin.service';
import { userService } from '../../../services/user.service';
import FeeWaiver from './Components/FeeWaiverTable';
import { GlobalAlertContext } from '../../../context/GlobalAlertContext';
import { SubscriptionApi } from 'services/subscription.service';
import { UserRole } from '_constants/UserRole';
import FaqA from './Faq/FaqA';

function ManageFeeWaiver() {
    const[feeWaivers, setFeeWaivers] = useState([]);
    const getFeeWaiver = async () => {
        const FeeWaiversRes = await SubscriptionApi.GetFeeWaiver()
        setFeeWaivers(FeeWaiversRes.data.items);
        // console.log(FeeWaiversRes.data.items)
    }

    useEffect(() => {
        getFeeWaiver();
    }, []);

    return (
        <GlobalAlertContext.Consumer>
            {
                alertObj => (
                    <>
                        <Grid>
                            <Row>
                                <Col>
                                    <Typography tag="h1">Manage Fee Waivers/Fee Discounts</Typography>
                                    
                                </Col>      
                            </Row>
                            <Row>                                
                                <FeeWaiver 
                                fetched={feeWaivers.length>0} 
                                feeWaivers = {feeWaivers}
                                />
                            </Row>
                            <Row>
                            </Row>
                        </Grid>
                    </>
                )
            }
        </GlobalAlertContext.Consumer> 
    );

}

export default ManageFeeWaiver;
